import React, { useState, useEffect, useCallback } from 'react';

import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import Layout from '../../components/Layout';
import Layer from '../../components/Layer';
import Policy01 from '../../components/Policy01';
import Policy02 from '../../components/Policy02';

import $ from "jquery"; // Maintain jQuery for policy if needed, but try to replace logic

const Join = (props) => {
  const navigate = useNavigate();

  // Inputs
  const [name, setName] = useState('');
  const [emailLocal, setEmailLocal] = useState('');
  const [emailDomain, setEmailDomain] = useState('naver.com');
  const [emailDirect, setEmailDirect] = useState('');
  const [password, setPassword] = useState('');
  const [passwordConfirm, setPasswordConfirm] = useState('');

  // Validation State
  const [emailCheckMsg, setEmailCheckMsg] = useState('');
  const [pwMsg, setPwMsg] = useState('');
  const [pwMatchMsg, setPwMatchMsg] = useState('');

  // Agreements
  const [agreeAll, setAgreeAll] = useState(false);
  const [agreePolicy01, setAgreePolicy01] = useState(false);
  const [agreePolicy02, setAgreePolicy02] = useState(false);

  // Handlers
  // Autofill can put a full address into the id box: split it into id + domain
  const onEmailLocalChange = (value) => {
    const at = value.indexOf('@');
    if (at < 0) return setEmailLocal(value);
    const domain = value.slice(at + 1).trim();
    setEmailLocal(value.slice(0, at));
    if (['naver.com', 'hanmail.net', 'daum.net', 'kakao.com', 'gmail.com'].includes(domain)) handleEmailDomainChange(domain);
    else { setEmailDomain('직접입력'); setEmailDirect(domain); }
  };

  const handleEmailDomainChange = (domain) => {
    setEmailDomain(domain);
    if (domain !== '직접입력') setEmailDirect('');
  };

  const handleAgreeAll = (checked) => {
    setAgreeAll(checked);
    setAgreePolicy01(checked);
    setAgreePolicy02(checked);
  };

  const checkEmailAvailability = useCallback(async () => {
    const finalEmailDomain = emailDomain === '직접입력' ? emailDirect : emailDomain;
    if (!emailLocal || !finalEmailDomain) return;
    const fullEmail = `${emailLocal}@${finalEmailDomain}`;

    try {
      const res = await axios.post('/api/auth/check-email', { email: fullEmail });
      if (res.data.exists) {
        setEmailCheckMsg('이미 사용 중인 이메일입니다.');
      } else {
        setEmailCheckMsg('사용 가능한 이메일입니다.');
      }
    } catch (err) {
      console.error(err);
    }
  }, [emailDomain, emailDirect, emailLocal]);

  useEffect(() => {
    const timer = setTimeout(() => {
      if (emailLocal) checkEmailAvailability();
    }, 500);
    return () => clearTimeout(timer);
  }, [emailLocal, checkEmailAvailability]);


  const handleJoin = async () => {
    // Validate
    const finalEmailDomain = emailDomain === '직접입력' ? emailDirect : emailDomain;
    if (!emailLocal || !finalEmailDomain) {
      alert('이메일을 입력해주세요.');
      return;
    }
    const fullEmail = `${emailLocal}@${finalEmailDomain}`;

    if (emailCheckMsg === '이미 사용 중인 이메일입니다.') {
      alert('이미 사용 중인 이메일입니다.');
      return;
    }

    if (!name) {
      alert('이름을 입력해주세요.');
      return;
    }

    // Password Regex
    const pwRegex = /^(?=.*[A-Za-z])(?=.*\d)[A-Za-z\d]{6,}$/;
    if (!pwRegex.test(password)) {
      alert('비밀번호는 영문+숫자 조합 6자리 이상이어야 합니다.');
      return;
    }

    if (password !== passwordConfirm) {
      alert('비밀번호가 일치하지 않습니다.');
      return;
    }

    if (!agreePolicy01 || !agreePolicy02) {
      alert('이용약관과 개인정보 수집·이용(필수)에 동의해주세요.');
      return;
    }

    try {
      await axios.post('/api/auth/join', {
        email: fullEmail,
        password: password,
        name: name
      });
      alert('회원가입이 완료되었습니다! 로그인해주세요.');
      navigate('/Login', { state: { email: true } });
    } catch (err) {
      console.error(err);
      if (err.response && err.response.data.error) {
        alert(err.response.data.error);
      } else {
        alert('회원가입 실패');
      }
    }
  };

  // jQuery Logic Replacement (Toggle Select)
  const [showSelect, setShowSelect] = useState(false);

  // Determine PW Messages
  useEffect(() => {
    if (password && !/^(?=.*[A-Za-z])(?=.*\d)[A-Za-z\d]{6,}$/.test(password)) {
      setPwMsg('영문+숫자 조합 6자릿수를 입력하세요.');
    } else {
      setPwMsg('');
    }
  }, [password]);

  useEffect(() => {
    if (passwordConfirm && password !== passwordConfirm) {
      setPwMatchMsg('비밀번호가 틀립니다.');
    } else {
      setPwMatchMsg('');
    }
  }, [password, passwordConfirm]);


  // Update AgreeAll if individual changes
  useEffect(() => {
    if (agreePolicy01 && agreePolicy02) setAgreeAll(true);
    else setAgreeAll(false);
  }, [agreePolicy01, agreePolicy02]);


  // Policy Modal
  const openPolicy01 = () => $('.policy01').show();
  const openPolicy02 = () => $('.policy02').show();

  return (
    <Layout header={{ title: '정보 입력', Backbtn: true, link: '/' }} containName='account'>

      <Layer layerName={'policy01'} title={'이용약관'}>
        <Policy01 />
      </Layer>

      <Layer layerName={'policy02'} title={'개인정보처리방침'}>
        <Policy02 />
      </Layer>

      <div className='join'>
        <div className="input-wrap">
          <label htmlFor="name">이름</label>
          <input type="text" id="name" placeholder="이름을 입력하세요" value={name} onChange={e => setName(e.target.value)} />
        </div>

        <div className="input-wrap">
          <label htmlFor="email">이메일</label>
          <div className="input-group">
            <div className="input-wrap">
              <input type="text" id="email" placeholder="이메일" value={emailLocal} onChange={e => onEmailLocalChange(e.target.value)} autoComplete="username" />
            </div>
            <div className="sign">@</div>
            <div className="input-wrap">
              <div className="select">
                <button type="button" onClick={() => setShowSelect(!showSelect)}>{emailDomain}</button>
                <ul style={{ display: showSelect ? 'block' : 'none' }}>
                  {['naver.com', 'hanmail.net', 'daum.net', 'kakao.com', 'gmail.com', '직접입력'].map(domain => (
                    <li key={domain} onClick={() => { handleEmailDomainChange(domain); setShowSelect(false); }}>{domain}</li>
                  ))}
                </ul>
              </div>
            </div>
          </div>
          {emailCheckMsg && <p className={`text-guide ${emailCheckMsg.includes('가능') ? 'text-colblue' : 'text-colred'}`} style={{ color: emailCheckMsg.includes('가능') ? '#007bff' : '#ff4d4f' }}>{emailCheckMsg}</p>}
          {emailDomain === '직접입력' && (
            <input type="text" id="email_direct" placeholder="직접 입력해주세요" value={emailDirect} onChange={e => setEmailDirect(e.target.value)} style={{ display: 'block', marginTop: '10px' }} />
          )}
        </div>


        <div className="input-wrap">
          <label htmlFor="pw01">비밀번호</label>
          <input type="password" id="pw01" placeholder="********" value={password} onChange={e => setPassword(e.target.value)} />
          {pwMsg && <p className="text-guide text-colred">{pwMsg}</p>}
        </div>

        <div className="input-wrap">
          <label htmlFor="pw02">비밀번호 확인</label>
          <input type="password" id="pw02" placeholder="********" value={passwordConfirm} onChange={e => setPasswordConfirm(e.target.value)} />
          {pwMatchMsg && <p className="text-guide text-colred">{pwMatchMsg}</p>}
        </div>

        <div className="input-wrap">
          <label>약관동의</label>
          <div className="check-group">
            <div className="input-check">
              <input type="checkbox" id="all_agree" checked={agreeAll} onChange={e => handleAgreeAll(e.target.checked)} />
              <label htmlFor="all_agree">전체 동의</label>
            </div>
            <div className="input-check">
              <input type="checkbox" id="policy01" checked={agreePolicy01} onChange={e => setAgreePolicy01(e.target.checked)} />
              <label htmlFor="policy01">이용약관 동의 (필수)</label>
              <button type="button" className="btn-agree" onClick={openPolicy01}><span className="visuallyhidden">약관보기</span></button>
            </div>
            <div className="input-check">
              <input type="checkbox" id="policy02" checked={agreePolicy02} onChange={e => setAgreePolicy02(e.target.checked)} />
              <label htmlFor="policy02">개인정보 수집·이용 동의 (필수)</label>
              <button type="button" className="btn-agree" onClick={openPolicy02}><span className="visuallyhidden">약관보기</span></button>
            </div>
          </div>
        </div>

        <button type="button" className="btn" onClick={handleJoin}>가입하기</button>
      </div>

    </Layout>
  );
};

export default Join;